import { useEffect, useState } from "react";
import { BsFillHexagonFill } from "react-icons/bs";

const LevelIndicator = ({ info }) => {
  const [colorLevel, setColorLevel] = useState("black");
  useEffect(() => {
    levelIndicator();
  });

  const levelIndicator = () => {
    let levelDB = info?.levels_byAccount?.items[0]?.id_level?.name;
    if (!!levelDB) {
      //console.log("info: ", info?.levels_byAccount?.items[0]?.id_level?.name);
      switch (levelDB) {
        case "training":
          setColorLevel("#81b0e8");
          break;
        case "copper":
          setColorLevel("#9F7A34");
          break;
        case "silver":
          setColorLevel("#B5B7BB");
          break;
        case "gold":
          setColorLevel("#D4AF37");
          break;

        default:
          setColorLevel("black");
          break;
      }
    } else {
      setColorLevel("black");
    }
  };

  const HexagonFig = () => {
    return <BsFillHexagonFill color={colorLevel} />;
  };

  return <HexagonFig />;
};

export default LevelIndicator;
